const FINANCE_STATUS_LABELS = Object.freeze({
  no_effective_bill: '无有效账单',
  no_overdue: '无逾期',
  overdue: '存在逾期',
  incomplete: '财务信息不完整',
  unavailable: '财务信息暂不可用'
})

function ensureSuccess(response, requireArray) {
  if (!response || response.code !== 200 || (requireArray && !Array.isArray(response.data))) {
    throw new Error(response && response.msg ? response.msg : 'Release information is unavailable')
  }
  return response.data
}

function loadCustomerReleasePage(http, transportType, rows, orderNoSelector) {
  const sourceRows = rows || []
  if (sourceRows.length === 0) {
    return Promise.resolve([])
  }
  const orders = sourceRows.map(row => ({
    transportType,
    orderNo: orderNoSelector(row)
  }))
  return http.post('/customer/release/orders/projections', { orders })
    .then(response => ensureSuccess(response, true))
}

function loadCustomerReleaseDetail(http, transportType, orderNo) {
  const path = '/customer/release/orders/' + encodeURIComponent(transportType)
    + '/' + encodeURIComponent(orderNo)
  return http.get(path).then(response => ensureSuccess(response, false))
}

function customerFinanceStatusLabel(financeStatus) {
  return FINANCE_STATUS_LABELS[financeStatus]
    || '未知财务状态 (' + (financeStatus || '-') + ')'
}

module.exports = {
  loadCustomerReleasePage,
  loadCustomerReleaseDetail,
  customerFinanceStatusLabel
}
